import React, { useState } from 'react';
import { Modal, Button, Form, CheckboxGroup, Checkbox, Input } from 'tea-component';
import '@/pages/intelligence/assets/scss/TopCharts/components/savePopup.scss';
import inputMap from './SaveListRender';
import { onFilterConfirm } from '@/pages/intelligence/components/Filter/index';
import useFilterSaveHook from '@/pages/intelligence/hooks/useFilterSaveHook';
import { connect, useIntl } from 'umi';
import { updateSameCountriesFilterValues } from '@intelligence/components/Filter/util';
import './SaveListRender.scss';

const trimmedStr = (str: string) => {
  if (typeof str !== 'string') {
    return '';
  }
  return str.trim();
};

export default function SavePopup(props: any) {
  const {
    saveOpen,
    close,
    inputList,
    internalValue,
    values,
    handlePopupConfirm,
    filterSaveType = '',
  } = props;

  // console.debug('SavePopup654321345628282828', props);

  const { formatMessage } = useIntl();
  const renderInputList = inputList?.filter((v: any) => v?.savePopupVisble !== 0) || [];
  const [errorMessage, setErrorMessage] = useState(''); // 错误校验信息
  const [confirmDisable, setConfirmDisable] = useState(true);
  const [formStatus, setFormStatus] = useState<string>('');
  const [filterName, setFilterName] = useState('');
  const { filterData, updateFilterSave } = useFilterSaveHook({
    filterSaveType,
  });
  const [confirmLoading, setConfirmLoading] = useState(false);
  const MAX_NUM = 30;
  // 默认不勾选的值
  const defaultChecks = renderInputList
    ?.filter((item) => item?.isNotSaveByDefault !== true) // 过滤掉默认不勾选的值
    .map((item) => item?.key);
  const [checkValues, setCheckValues] = useState(defaultChecks);

  const renderFilterList = () => {
    return renderInputList?.map((t: any, indexNum: number) => {
      // type相同时key可以不同： 如时间筛选器type都是rangeTime,但key可以代表是范围的还是releaseTime
      const renderType = t?.type ?? t?.key;
      const inputType = t?.key ?? t?.type;
      // @ts-ignore
      const render = inputMap[renderType];
      const valueItem = internalValue?.[inputType];
      if (!render) {
        console.error('请给筛选器添加一个render函数！');
      }

      return t?.visible !== 2 ? (
        <Checkbox
          key={indexNum}
          className={
            inputType === 'metric_selection_for_trends'
              ? 'model-form-checkbox-all'
              : 'model-form-checkbox'
          }
          name={inputType}
        >
          {render &&
            render({
              key: inputType,
              valueItem,
              ...(t || {}),
            })}
        </Checkbox>
      ) : (
        ''
      );
    });
  };

  function filterInternalValue(checkValues: string[], internalValue: any) {
    const filteredItems = checkValues.reduce((result, key) => {
      result[key] = internalValue[key];
      return result;
    }, {});
    return filteredItems;
  }

  const onConfirm = async () => {
    // 过滤出要保存的值
    const filteredInternalValue = filterInternalValue(checkValues, internalValue);

    // console.log('checkValues', checkValues);
    // console.log('internalValue', internalValue);
    // console.log('filteredInternalValue', filteredInternalValue);

    const { error, value, apiValue } = onFilterConfirm(filteredInternalValue);
    const trimFilterName = trimmedStr(filterName);
    // api数据进行特殊处理，比如时间的一些特殊继承类型
    const newVal: any = updateSameCountriesFilterValues(value);
    const newapiValue: any = updateSameCountriesFilterValues(apiValue);
    setConfirmLoading(true);

    // console.log('newValnewVal', newVal);
    // console.log('newapiValue', newapiValue);

    // 接口调用
    const isSuccess = await updateFilterSave({
      name: trimFilterName,
      data: JSON.stringify({ value: newVal, apiValue: newapiValue }),
    });
    if (isSuccess) {
      // 如果接口调用成功了，需要选中该保存的值
      handlePopupConfirm && handlePopupConfirm(trimFilterName);
      close();
    }
    setConfirmLoading(false);
  };

  const setErrorFunc = (val: string) => {
    const filterNamesList = filterData?.map((item: any) => item?.name || '');
    const isSame = filterNamesList?.includes(trimmedStr(val));
    const isNull = trimmedStr(val) === '';
    const isMax = val?.length > MAX_NUM;
    setConfirmDisable(isNull || isMax);
    if (isSame) {
      setErrorMessage(formatMessage({ id: 'dbi_filterSave_replace_setting' }));
      // setFormStatus('validating');
      setFormStatus('error');
    } else if (isMax) {
      setErrorMessage(formatMessage({ id: 'dbi_filterSave_input_maximum' }, { max: MAX_NUM }));
      setFormStatus('error');
    } else {
      setErrorMessage('');
      setFormStatus('');
    }
  };
  const handleNameOnChange = (val: string) => {
    setFilterName(val);
    setErrorFunc(val);
  };
  return (
    <Modal
      visible={saveOpen}
      size="l"
      caption={formatMessage({ id: 'dbi_filterSave_filter_setting' })}
      className="dbi-save-model dbi-save-model-filter"
      onClose={close}
    >
      <Modal.Body>
        <div className="model-text">{formatMessage({ id: 'dbi_filterSave_setting_info' })}</div>
        <Form className="model-form">
          <Form.Item
            label={formatMessage({ id: 'dbi_filterSave_setting_name' })}
            showStatusIcon={false}
            status={formStatus}
            message={errorMessage}
          >
            <Input
              placeholder={formatMessage({ id: 'dbi_filterSave_enter_a_name' })}
              className="model-input"
              value={filterName}
              onChange={handleNameOnChange}
            />
          </Form.Item>
          <Form.Item
            label={formatMessage({ id: 'dbi_filterSave_save_item' })}
            showStatusIcon={false}
          >
            <CheckboxGroup
              className="model-form-group"
              value={checkValues}
              onChange={(value) => {
                setCheckValues(value);
              }}
            >
              {renderFilterList()}
            </CheckboxGroup>
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={onConfirm}
          disabled={confirmDisable || checkValues.length === 0}
          loading={confirmLoading}
        >
          {formatMessage({ id: 'common_confirm' })}
        </Button>
        <Button type="weak" onClick={close}>
          {formatMessage({ id: 'common_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
